export const ACTION_GET_HAPPINESS_TIPS_CATEGORIES = "ACTION_GET_HAPPINESS_TIPS_CATEGORIES";
export const ACTION_POST_CREATE_HAPPINESS_TIPS_CATEGORIES = "ACTION_POST_CREATE_HAPPINESS_TIPS_CATEGORIES";
export const ACTION_PUT_UPDATE_HAPPINESS_TIPS_CATEGORIES = "ACTION_PUT_UPDATE_HAPPINESS_TIPS_CATEGORIES";
export const ACTION_DELETE_HAPPINESS_TIPS_CATEGORIES = "ACTION_DELETE_HAPPINESS_TIPS_CATEGORIES";
